import React from "react";
import styled from "styled-components";
import { PathwayButton, PathwayLinkButton } from "../../../../_UI/Components/PathwayButtons";
import { useNavigate } from "react-router";
import PathwaySwitchInputGroup from "../../../../_UI/Components/Inputs/PathwaySwitchInputGroup";
import { Paragraph } from "../../../../_UI/StyledComponents/StyledComponents";

const StripeMarketplaceNewUserRegistrationScreen = (props) => {
    const navigate = useNavigate();

    return (
        <UserGrid>
            <LoginRow>
                <PathwaySwitchInputGroup
                    onChange={props.handleTosChange}
                    value={props.acceptTos}
                    name="acceptTos"
                    dataCy="stripe-accepttos-registration"
                    label={
                        <Paragraph>
                            Ich stimme der{" "}
                            <a
                                href={
                                    "https://app.pathway-solutions.de/Nutzungsvereinbarung_Platform.pdf"
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Nutzungsvereinbarung
                            </a>{" "}
                            in der derzeit gültigen Fassung zu.
                        </Paragraph>
                    }
                />
                <PathwaySwitchInputGroup
                    onChange={props.handleDpaChange}
                    value={props.acceptDpa}
                    name="acceptDpa"
                    dataCy="stripe-acceptdpa-registration"
                    label={
                        <Paragraph>
                            Ich stimme dem Vertrag zur{" "}
                            <a
                                href={"https://app.pathway-solutions.de/AVV_Platform.pdf"}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Auftragsverarbeitung
                            </a>{" "}
                            zu.
                        </Paragraph>
                    }
                />
            </LoginRow>
            <br />
            <ButtonArea>
                <PathwayButton
                    disabled={!props.acceptDpa || !props.acceptTos || props.payloadSubmitted}
                    onClick={props.handleSubmitInstallationRequest}
                    buttonCyData={"stripe-Install-button"}
                >
                    Confirm
                </PathwayButton>
                <PathwayLinkButton onClick={() => navigate("/login")}>Login</PathwayLinkButton>
            </ButtonArea>
        </UserGrid>
    );
};

export default StripeMarketplaceNewUserRegistrationScreen;

const UserGrid = styled.div`
    display: grid;
`;

const LoginRow = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
`;

const ButtonArea = styled.div`
    display: grid;
    grid-template-columns: 0.5fr max-content;
    justify-content: space-between;
`;
